import styled, { css } from 'styled-components';

import type { IMailSubscriptionTheme } from '@/shared/themes/types';

export const CheckboxInput = styled.input`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    &:checked {
      color: ${theme.defaultPrimaryColor};
    }
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    color: ${theme.defaultDarkColor};
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeight.medium};
    line-height: 19px;

    ${CheckboxInput} {
      margin-right: 5px;
    }
  `}
`;

export const Text = styled.label`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    display: inline;
    color: ${theme.defaultDarkColor};
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeight.medium};
    line-height: 19px;
    position: relative;
    bottom: 1px;
  `}
`;
